// @core/api/endpoints/product/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateProduct } from './create_product';
import { CreateProductCategory } from './create_product_category';
import { CreateProductDependency } from './create_product_dependency';
import { CreateProductProfile } from './create_product_profile';
import { CreateProductReview } from './create_product_review';
import { DeleteProduct } from './delete_product';
import { DeleteProductCategory } from './delete_product_category';
import { DeleteProductDependency } from './delete_product_dependency';
import { GetMarketplaceMetadata } from './get_marketplace_metadata';
import { GetMyProductProfile } from './get_my_product_profile';
import { GetProduct } from './get_product';
import { GetProductBySlug } from './get_product_by_slug';
import { GetProductDependency } from './get_product_dependency';
import { ListDependentProducts } from './list_dependent_products';
import { ListMyProductProfiles } from './list_my_product_profiles';
import { ListProductCategories } from './list_product_categories';
import { ListProductDependencies } from './list_product_dependencies';
import { ListProductReviews } from './list_product_reviews';
import { ListProducts } from './list_products';
import { ListProductsByCategory } from './list_products_by_category';
import { PublishProduct } from './publish_product';
import { RemoveProductCategory } from './remove_product_category';
import { SetProductCategory } from './set_product_category';
import { SetProductStatus } from './set_product_status';
import { UpdateMarketplaceMetadata } from './update_marketplace_metadata';
import { UpdateProduct } from './update_product';
import { UpdateProductCategory } from './update_product_category';
import { UpdateProductDependency } from './update_product_dependency';
import { UpdateProductProfile } from './update_product_profile';
import { ValidateProductDependencies } from './validate_product_dependencies';

// Re-export individual endpoints
export {
  CreateProduct,
  CreateProductCategory,
  CreateProductDependency,
  CreateProductProfile,
  CreateProductReview,
  DeleteProduct,
  DeleteProductCategory,
  DeleteProductDependency,
  GetMarketplaceMetadata,
  GetMyProductProfile,
  GetProduct,
  GetProductBySlug,
  GetProductDependency,
  ListDependentProducts,
  ListMyProductProfiles,
  ListProductCategories,
  ListProductDependencies,
  ListProductReviews,
  ListProducts,
  ListProductsByCategory,
  PublishProduct,
  RemoveProductCategory,
  SetProductCategory,
  SetProductStatus,
  UpdateMarketplaceMetadata,
  UpdateProduct,
  UpdateProductCategory,
  UpdateProductDependency,
  UpdateProductProfile,
  ValidateProductDependencies,
};

// Namespace export for convenient usage
export const productApi = {
  CreateProduct,
  CreateProductCategory,
  CreateProductDependency,
  CreateProductProfile,
  CreateProductReview,
  DeleteProduct,
  DeleteProductCategory,
  DeleteProductDependency,
  GetMarketplaceMetadata,
  GetMyProductProfile,
  GetProduct,
  GetProductBySlug,
  GetProductDependency,
  ListDependentProducts,
  ListMyProductProfiles,
  ListProductCategories,
  ListProductDependencies,
  ListProductReviews,
  ListProducts,
  ListProductsByCategory,
  PublishProduct,
  RemoveProductCategory,
  SetProductCategory,
  SetProductStatus,
  UpdateMarketplaceMetadata,
  UpdateProduct,
  UpdateProductCategory,
  UpdateProductDependency,
  UpdateProductProfile,
  ValidateProductDependencies,
};
